import couponTransformer from '../../transformers/coupon';
import instance from './instance';
export default (query) =>
  instance()
    .get(`/coupons/${query.couponId}/meta`, { params: query || {} })
    .then(({ data: { data, totalCount } }) => ({
      data: couponTransformer.formatMetaTable(data),
      totalCount,
    }))
    .catch((err) => err);
